import ScrollMagic from 'scrollmagic';
import scrollController from 'Models/scroll-controller';

export default function scrolledIntoView (element) {
    let scrollScene;
    const offsetSetting = element.dataset.offset;
    const notifyElements = element.dataset.notifyElements;
    const updateOnEvent = element.dataset.updateOnEvent;

    function init () {
        initScrollScene();
        if (updateOnEvent) {
            addListeners();
        }
    }

    function addListeners () {
        element.addEventListener(updateOnEvent, refreshScene);
    }

    function initScrollScene () {
        const offset = offsetSetting ? parseInt(offsetSetting) : 0;

        scrollScene = new ScrollMagic.Scene({
            triggerElement: element,
            triggerHook: 1,
            duration: getDuration(),
            offset: offset,
        });

        if (notifyElements) {
            const elementsToNotify = element.querySelectorAll(notifyElements);

            scrollScene.on('enter', () => {
                elementsToNotify.forEach(elementToNotify => {
                    elementToNotify.dispatchEvent(new CustomEvent('in-view'));
                    elementToNotify.dataset.inViewAlready = true;
                });
            });
        }

        scrollScene.setClassToggle(element, 'in-view');
        scrollScene.addTo(scrollController);
    }

    function getDuration () {
        return element.offsetHeight + window.innerHeight;
    }

    function refreshScene () {
        scrollScene.duration(getDuration());
        scrollScene.refresh();
    }

    init();
}
